// SPDX-License-Identifier: AGPL-3.0-or-later

import styles from '@app/features/app/components/layout/ChannelItemIcon.module.css';
import {stopPropagationOnEnterSpace} from '@app/features/input/utils/KeyboardUtils';
import FocusRing from '@app/features/ui/focus_ring/FocusRing';
import {Tooltip} from '@app/features/ui/tooltip/Tooltip';
import type {Icon} from '@phosphor-icons/react';
import {clsx} from 'clsx';
import {observer} from 'mobx-react-lite';

interface ChannelItemIconProps {
	icon: Icon;
	label: string;
	onClick?: () => void;
	className?: string;
	selected?: boolean;
}
export const ChannelItemIcon = observer(
	({icon: Icon, label, onClick, className, selected = false}: ChannelItemIconProps) => {
		return (
			<Tooltip text={label}>
				<FocusRing offset={-2} ringClassName={styles.iconFocusRing}>
					<button
						type="button"
						className={clsx(
							styles.iconButton,
							selected ? styles.iconButtonSelected : styles.iconButtonDefault,
							className,
						)}
						aria-label={label}
						onClick={(e) => {
							e.stopPropagation();
							onClick?.();
						}}
						onKeyDown={stopPropagationOnEnterSpace}
					>
						<Icon className={styles.icon} />
					</button>
				</FocusRing>
			</Tooltip>
		);
	},
);
